import { AbstractControl, ValidationErrors } from '@angular/forms';

export function codAmountValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = control.value;
  if (value === null || value === undefined || value === '') {
    return { required: true };
  }

  const numericValue = parseFloat(value);
  if (isNaN(numericValue) || numericValue <= 0) {
    return { codAmountInvalid: true };
  }

  return null;
}
